import styled from "styled-components";

export const MiniCardsWrapper = styled.section`
  display: flex;
  flex: 65;
  flex-wrap: wrap;
  flex-direction: row;
`;
